import React from "react";
import { Images } from "./../../assets/common";
import { useHistory } from "react-router-dom";
import { Box, Stack, Typography, Button } from "@mui/material";
import { fullName, getErrorString } from "../../constants/function";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "../Notifier";
import { useTranslation } from "react-i18next";
export default function FollowRow(props) {
  const { t } = useTranslation("common");
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);

  const handleClick = async () => {
    try {
      const payload = {
        following: props["user"]["_id"],
        status: !props["follow"]["isFollowed"],
      };
      setLoading(true);
      const response = props["follow"]["isFollowed"]
        ? await ApiService.UNFOLLOW(payload)
        : await ApiService.FOLLOW(payload);
      props.onHandleFollow(
        props["isFollower"] ? props["isFollower"] : false,
        !props["follow"]["isFollowed"],
        props["index"]
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <img
        className="avatar"
        src={
          props["user"]["profileImg"] &&
          props["user"]["profileImg"]["filePath"] !== ""
            ? props["user"]["profileImg"].filePath
            : Images.dummy1
        }
        alt="img"
      />
      <Box sx={{ margin: "0 auto 0 10px" }}>
        <Typography
          className="fs-14 _cp"
          onClick={() =>
            history.push(`/app/ArtistProfile/${props["user"]["_id"]}`)
          }
        >
          {fullName(props["user"] ? props["user"] : "")}
        </Typography>
        <Typography className="fs-13 fade-text">
          {`${props["follow"]["followerCount"]} ${t(
            "follow.followList.subheader"
          )}`}
        </Typography>
      </Box>
      <Box>
        <Button
          disabled={
            props["isFollower"] &&
            props["follow"]["follower"] &&
            props["userId"] === props["follow"]["follower"]["_id"]
          }
          sx={{
            minWidth: "100px",
            height: "28px !important",
            fontSize: "13px !important",
          }}
          variant={props["isFollow"] ? "contained" : "outlined"}
          color={props["isFollow"] ? "success" : "default"}
          onClick={() => handleClick()}
        >
          {props["follow"]["isFollowed"]
            ? t("follow.followList.button2")
            : t("follow.followList.button1")}
        </Button>
      </Box>
      {loading ? <Loader /> : null}
    </Stack>
  );
}
